// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__fvTiY","content":"Banner_content__Eaaks","text":"Banner_text__p0E9J","image":"Banner_image__Oi+0k"};